// extracted by mini-css-extract-plugin
export default {"notice":"notice_notice__BWN1H"};